// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* Target only this table's horizontal scrollbar */
.custom-scrollbar-table .ant-table-body::-webkit-scrollbar {
  height: 6px; /* 👈 smaller height for horizontal scrollbar */
}

.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 4px;
}

/* Optional for Firefox */
.custom-scrollbar-table .ant-table-body {
  scrollbar-width: thin;
  scrollbar-color: #999 #f1f1f1;
}

/* styles.css or your global stylesheet */
.ant-tooltip-inner {
  background-color: #fff !important; /* white background */
  color: #222 !important; /* dark neutral text for readability */
  border: 1px solid #e2e8f0 !important; /* subtle but visible border (Tailwind slate-200) */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important; /* much stronger shadow for depth */
  font-size: 1rem;
  line-height: 1.5;
}

@keyframes tire-roll {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.my-img-two {
  animation: tire-roll 1.5s infinite linear;
  filter: drop-shadow(0px 4px 6px rgba(0,0,0,0.2)); /* Yeh glow effect dega */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,kDAAkD;AAClD;EACE,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,yCAAyC;AACzC;EACE,iCAAiC,EAAE,qBAAqB;EACxD,sBAAsB,EAAE,sCAAsC;EAC9D,oCAAoC,EAAE,mDAAmD;EACzF,qDAAqD,EAAE,mCAAmC;EAC1F,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,yCAAyC;EACzC,gDAAgD,EAAE,yBAAyB;AAC7E","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* Target only this table's horizontal scrollbar */\n.custom-scrollbar-table .ant-table-body::-webkit-scrollbar {\n  height: 6px; /* 👈 smaller height for horizontal scrollbar */\n}\n\n.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-thumb {\n  background-color: #999;\n  border-radius: 4px;\n}\n\n/* Optional for Firefox */\n.custom-scrollbar-table .ant-table-body {\n  scrollbar-width: thin;\n  scrollbar-color: #999 #f1f1f1;\n}\n\n/* styles.css or your global stylesheet */\n.ant-tooltip-inner {\n  background-color: #fff !important; /* white background */\n  color: #222 !important; /* dark neutral text for readability */\n  border: 1px solid #e2e8f0 !important; /* subtle but visible border (Tailwind slate-200) */\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important; /* much stronger shadow for depth */\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n@keyframes tire-roll {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.my-img-two {\n  animation: tire-roll 1.5s infinite linear;\n  filter: drop-shadow(0px 4px 6px rgba(0,0,0,0.2)); /* Yeh glow effect dega */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
